import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { unregister } from './registerServiceWorker';
import { BrowserRouter, Route } from 'react-router-dom';

import './i18n';

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <BrowserRouter>
    <Route path="/" component={App} />
  </BrowserRouter>,
);

unregister();
